import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SwapService } from './core/services/swap.service';
import { BroadcastEvent } from './core/models/dataContract.model';
import { HelperService } from './core/services/helper.service';
import { ConfigService } from './core/services/config.service';
import { AuthService } from './core/services/auth.service';
import { StartupService } from './core/services/startup.service';
import { UtilsService } from './core/services/utils.service';
import { StorageService } from './core/services/storage.service';
import { ResourceService } from './core/services/resource.service';

import moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '[style.--fontSize.px]': 'fontSize',
  },
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  uiTheme = '';

  fontSize = 16;

  private keepAliveCheckHandler = () => {
    if (!document.hidden) {
      if (moment().diff(this.resource.apiActivationTime) > this.config.getConfig('keepAliveCheckPeriod', 3600000)) {
        try {
          if (this.router.url) {
            let actUrl = this.router.url;
            const sidenavPos = actUrl.indexOf('/sidenav:');
            if (sidenavPos > 0) {
              actUrl = actUrl.substring(0, sidenavPos).replace('(', '');
            } else {
              const pos = actUrl.indexOf('?');
              actUrl = pos > 0 ? actUrl.substring(0, pos) : this.router.url;
            }
            if (actUrl && actUrl.toLowerCase() !== '/expired') {
              this.resource.apiActivationUrl = actUrl;
            }
          }
        } catch { }
        this.router.navigate(['/expired']);
      }
    }
  }

  constructor(
    private swap: SwapService,
    private helper: HelperService,
    private config: ConfigService,
    private auth: AuthService,
    private router: Router,
    private startup: StartupService,
    private utils: UtilsService,
    private storage: StorageService,
    private resource: ResourceService,
  ) {
    window.onresize = () => {
      this.swap.verifyWindowSize();
    };
  }

  ngOnInit() {
    const pathBeforeLoad = window.location.pathname;
    if (pathBeforeLoad && pathBeforeLoad.startsWith('/app/')) {
      this.storage.setItem(this.utils.localStoragePathBeforeLoad, pathBeforeLoad);
    }

    window.addEventListener('focus', this.keepAliveCheckHandler);
    document.addEventListener('visibilitychange', this.keepAliveCheckHandler);

    this.subscription.add(
      this.swap.broadcasted.pipe(
        tap((event: BroadcastEvent) => {
          switch (event.name) {
            case 'resource-service-loaded':
              {
                this.uiTheme = this.helper.getCurrentUIThemeName();
                Array.from(document.body.classList).forEach(className => {
                  document.body.classList.remove(className);
                })
                document.body.classList.add(this.uiTheme);

                this.fontSize = this.config.getConfig('attributeFontSize', 16);

                if (this.config.getConfig('transparentDesign', false)) {
                  document.body.classList.add('legacy-design');
                } else {
                  document.body.classList.remove('legacy-design');
                }
              }
              break;
            case 'theme-changed':
              this.uiTheme = event.parameter;
              Array.from(document.body.classList).forEach(className => {
                document.body.classList.remove(className);
              })
              document.body.classList.add(this.uiTheme);
              if (this.config.getConfig('transparentDesign', false)) {
                document.body.classList.add('legacy-design');
              }
              break;
            default:
              break;
          }
        })
      ).subscribe()
    );

    if (this.auth.isLoggedIn) {
      this.subscription.add(
        this.startup.init().pipe(
          tap((result: boolean) => {
            if (result) {
              this.router.navigate(['/splash']);
            }
          })
        ).subscribe()
      );
    }
  }

  ngOnDestroy() {
    window.removeEventListener('focus', this.keepAliveCheckHandler);
    document.removeEventListener('visibilitychange', this.keepAliveCheckHandler);
    this.subscription.unsubscribe();
  }
}

